import React, { useMemo } from 'react';
import GroupIcon from '@mui/icons-material/Group';
import AssignmentIcon from '@mui/icons-material/Assignment';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';
import { useTranslation } from 'react-i18next';
import DrawerBar from '@/common/components/NavigationBar/index';
import { routes } from '@/app/routing/index';

const Navigation = () => {
  const { t } = useTranslation();
  const list = useMemo(
    () => [
      {
        link: routes.adminPanel.decedents,
        text: (
          <>
            <GroupIcon /> {t('Decedent accounts')}
          </>
        ),
      },
      {
        link: routes.adminPanel.accessCodes,
        text: (
          <>
            <AssignmentIcon /> {t('Access Codes')}
          </>
        ),
      },
      {
        link: routes.adminPanel.resellers,
        text: (
          <>
            <HomeRepairServiceIcon /> {t('Resellers')}
          </>
        ),
      },
    ],
    [t]
  );

  return <DrawerBar list={list} admin />;
};

export default Navigation;
